import { connect } from "react-redux";
import React from "react";

// react component for creating dynamic tables
import ReactTable from "react-table";
import SweetAlert from "react-bootstrap-sweetalert";
import Tooltip from '@material-ui/core/Tooltip';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Dvr from "@material-ui/icons/Dvr";
import Favorite from "@material-ui/icons/Favorite";
import Close from "@material-ui/icons/Close";
import People from "@material-ui/icons/People";
import Add from "@material-ui/icons/PersonAdd";


// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import { dataTable } from "variables/general.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import { fetchUsersRequest, suspendUserRequest, fetchUsersReset, SuspendUserReset } from "../../../actions/users"


const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
};

const successButtonStyle = {
  backgroundColor: "#4CAF50", /* Green */
  border: "none",
  color: "white",
  padding: "15px 32px",
  textAlign: "center",
  textDecoration: "none",
  display: "inline-block",
  fontSize: "16px"
}

const dangerButtonStyle = {
  backgroundColor: "red", /* Green */
  border: "none",
  color: "white",
  padding: "15px 32px",
  textAlign: "center",
  textDecoration: "none",
  display: "inline-block",
  fontSize: "16px"
}




class ViewUsers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null
  }
}

componentWillMount() {
  this.props.dispatch(fetchUsersRequest());
}

suspendUser(user){
  console.log("Are you sure you want to suspend user: ", user.firstName + " "+ user.middleName+ " " + user.lastName);
  this.props.dispatch(suspendUserRequest(user._id))
  this.hideAlert()
}

suspendWarningAlert(user) {
  const userName = user.firstName + " "+ user.middleName+ " " + user.lastName
  this.setState({
    alert: (
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure?"
        onConfirm={() => this.suspendUser(user)}
        onCancel={() => this.cancelSuspendAlert()}
        confirmBtnStyle={successButtonStyle}
        cancelBtnStyle={dangerButtonStyle}
        confirmBtnText="Yes, suspend it!"
        cancelBtnText="Cancel"
        showCancel
      >
        <p style={{fontSize:"20px"}}>You want to suspend {userName}!</p>
      </SweetAlert>
    )
  });
}

cancelSuspendAlert() {
  this.setState({
    alert: (
      <SweetAlert
        danger
        style={{ display: "block", marginTop: "-100px" }}
        title="Cancelled"
        onConfirm={() => this.hideAlert.bind(this)}
        onCancel={() => this.hideAlert.bind(this)}
        confirmBtnStyle={successButtonStyle}
      >
      </SweetAlert>
    )
  });
}

hideAlert() {
  this.setState({
    alert: null
  });
}

displayErrorFeedback() {
  const e = this.errorMessage()
  return <SweetAlert
    danger
    style={{ display: "block", marginTop: "-100px" }}
    title="Cancelled"
    onConfirm={() => this.reset()}
    onCancel={() => this.reset()}
    confirmBtnStyle={dangerButtonStyle}
  >
    <div>
      {e.map((item, index) => {

        return <div key={index}> {item}</div>
      })}
    </div>
  </SweetAlert>
}

displaySuccessFeedback() {
  return <SweetAlert
  success
  style={{ display: "block", marginTop: "-100px" }}
  title="Suspended!"
  onConfirm={() => this.reset()}
  confirmBtnStyle={successButtonStyle}
>
  User has been supspended.
</SweetAlert>
}


displayLoader() {
  return <Dialog
    open={true}
    onClose={this.hideAlert}
    aria-labelledby="form-dialog-title"
  >
    <DialogContent>
      <CircularProgress />
    </DialogContent>
  </Dialog>
}

errorMessage() {
  let e = this.props.usersData.suspendUserErrors
  if (Array.isArray(e)) {
    let i;
    let el = []
    for (i = 0; i < e.length; i++) {
      let obj = e[i].constraints
      for (var property in obj) {
        el.push(obj[property] + '; ')
      }
    }
    return el

  }
  else if (e.message) {
    return [e.message]
  } else {
    return ["unexpected Error occured"]
  }
}

reset() {
  this.props.dispatch(SuspendUserReset())
}
  render() {
    let users = (this.props.usersData.users != null) ? this.props.usersData.users : []
    const externalUser = this.props.loginData.AuthData ? this.props.loginData.AuthData.user.external : null;

    const { classes } = this.props;
    
    return (
      <GridContainer>
        <div>
          <div style={{ textAlign: "center" }}>
            {this.props.usersData.suspendUserErrors ? (this.displayErrorFeedback()) : ('')}
            {this.props.usersData.suspendUserSuccess ? (this.displaySuccessFeedback()) : ('')}
            {this.props.usersData.suspendUserLoader ? (this.displayLoader()) : ('')}
            {this.props.usersData.fetchLoader ? (this.displayLoader()) : ('')}

          </div>
        </div>
      {this.state.alert}
        <GridItem xs={12}>
        <center>
          
          {(!externalUser ) ?
        <Button color="info" onClick={() => this.props.history.push('/admin/register')}
      >
        <Add />
        Register User
      </Button> : '' }

          </center>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="info">
                <People />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>List of Users in the system</h4>
            </CardHeader>
            <CardBody>
              <ReactTable
                data={users.map((user, key) => {
                  return {
                    id: key,
                    name: user.firstName + " "+ user.middleName+ " " + user.lastName,
                    role: user.role,
                    company: user.company ? user.company.comapanyName : 'N/A',
                    email: user.email,
                    nationalId: user.nationalId,
                    passport: user.passportNumber,
                    phoneNumber: user.phoneNumber,
                    actions: (
                      <div className="actions-right">
                        <Tooltip title="Suspend user" placement="top-start">
                       <Button
                          justIcon
                          round
                          simple
                          onClick={this.suspendWarningAlert.bind(this, user)}
                          color="danger"
                          className="remove"
                        >
                          <Close />
                        </Button>
                        </Tooltip>
                      </div>
                    )
                  };
                })
              }
                filterable
                columns={[
                  {
                    Header: "Name",
                    accessor: "name"
                  },
                  {
                    Header: "Role",
                    accessor: "role"
                  },
                  {
                    Header: "Company",
                    accessor: "company"
                  },
                  {
                    Header: "Email",
                    accessor: "email"
                  },
                  {
                    Header: "Nationan Id",
                    accessor: "nationalId"
                  },
                  {
                    Header: "Passport",
                    accessor: "passport"
                  },
                  {
                    Header: "Phone",
                    accessor: "phoneNumber"
                  },
                  {
                    Header: "Actions",
                    accessor: "actions",
                    sortable: false,
                    filterable: false
                  }
                ]}
                defaultPageSize={30}
                showPaginationTop
                showPaginationBottom={false}
                className="-striped -highlight"
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(styles)(
  connect(state => ({
    usersData: state.usersState,
    loginData: state.loginState
  }))(ViewUsers)
);
